/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetJsonWebKeySetSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetJsonWebKeySetRequest = {
  /**
   * The ID of the key set to get.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetJsonWebKeySetSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetJsonWebKeySetSecurity$outboundSchema: z.ZodMiniType<
  GetJsonWebKeySetSecurity$Outbound,
  GetJsonWebKeySetSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getJsonWebKeySetSecurityToJSON(
  getJsonWebKeySetSecurity: GetJsonWebKeySetSecurity,
): string {
  return JSON.stringify(
    GetJsonWebKeySetSecurity$outboundSchema.parse(getJsonWebKeySetSecurity),
  );
}

/** @internal */
export type GetJsonWebKeySetRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetJsonWebKeySetRequest$outboundSchema: z.ZodMiniType<
  GetJsonWebKeySetRequest$Outbound,
  GetJsonWebKeySetRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getJsonWebKeySetRequestToJSON(
  getJsonWebKeySetRequest: GetJsonWebKeySetRequest,
): string {
  return JSON.stringify(
    GetJsonWebKeySetRequest$outboundSchema.parse(getJsonWebKeySetRequest),
  );
}
